"use client"

import * as AccordionPrimitive from "@radix-ui/react-accordion"
import * as React from "react"
import { ChevronDown } from "lucide-react"
import { cn } from '@/utils/index'

const AccordionTrigger = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Header asChild className="dark:AccordionTrigger flex w-full">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cn(
        "flex flex-1 items-center justify-between border-b bg-white transition-all [&[data-state=open]>div>svg]:rotate-180",
        className
      )}
      {...props}
    >
      <div className="flex w-full items-center justify-between">
        {children}
        <ChevronDown className="size-3 shrink-0 text-black transition-transform duration-200 dark:text-gray-300" />
      </div>
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
))
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName

export default AccordionTrigger
